const mapping: Record<string, string> = {
  id: 'i=>i.Id',
}

export const mapSortPrintTextItemsParam = (key: string) => mapping[key]
